module.exports = __webpack_public_path__ + "static/img/1_2_2_1.d919821c.jpg";